package model

import kotlinx.serialization.Serializable

@Serializable
data class DeleteCardBody(
    val consumerLoyaltyProgramGuid: String,
    val card: Card,
)
